import { useState } from 'react';
import { Navbar, Container, Nav, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './NavbarComponent.css'; // Import CSS styles
import logo from '../assets/hostlink-logo-transparent.png';

const NavbarComponent = () => {
  const [expanded, setExpanded] = useState(false);

  const handleNavClick = () => {
    setExpanded(false);
  };

  return (
    <Navbar className="custom-navbar" expand="lg" expanded={expanded} onToggle={setExpanded}>
    <Container>
      {/* Logo or Brand */}
      <Navbar.Brand as={Link} to="/" className="logo" onClick={handleNavClick}>
        <img
          src={logo}
          alt="Logo"
          className="logo-img"
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        {/* Center Nav Links */}
        <Nav className="mx-auto">
          <Nav.Link as={Link} to="/" onClick={handleNavClick}>Home</Nav.Link>
          <Nav.Link href="/#about" onClick={handleNavClick}>About</Nav.Link>
          <Nav.Link as={Link} to="/offers" onClick={handleNavClick}>Affiliates</Nav.Link>
          <Nav.Link as={Link} to="/contact" onClick={handleNavClick}>Contact</Nav.Link>
        </Nav>
        {/* Right-aligned buttons */}
        <Nav className="ms-auto">
          <Button variant="outline-primary" className="auth-button" onClick={handleNavClick}>
            Login
          </Button>
          <Button variant="primary" className="auth-button" onClick={handleNavClick}>
            Register
          </Button>
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
  );
};

export default NavbarComponent;
